import { RootState } from '@/Redux/RootReducer';
import { createSelector } from '@reduxjs/toolkit';
import { genLogisticTypesDataSelectors } from '@/Redux/DynamicData/GenLogisticTypesData/selector';

const logisticTypes = genLogisticTypesDataSelectors.logisticTypes;

const applicationAccessState = (state: RootState) => state.warehouseLogisticsPage.applicationAccess;

const selectedCountryCode = createSelector(applicationAccessState, (state) => state.selectedCountryCode);

const connectionStatus = createSelector(applicationAccessState, (state) => state.connectionStatus);

const selectedCountryZone = createSelector(applicationAccessState, (state) => {
  return state.countryZones.find((x) => x.country === state.selectedCountryCode);
});

const logisticTypeOptions = createSelector([applicationAccessState, logisticTypes], (state, logisticTypes) => {
  return logisticTypes
    .filter((x) => x.country === state.selectedCountryCode)
    .map((x) => {
      return { key: x.id, value: x.locName ?? x.name };
    });
});

export const applicationAccessSelectors = {
  logisticTypeOptions,
  selectedCountryCode,
  selectedCountryZone,
  connectionStatus,
};
